<template>
  <Card tag="form" class="project-mutate-basis" @submit.prevent="$emit('submit')">
    <template #default>
      <div class="project-mutate-basis__input">
        <InputComponent
          v-model="value.name"
          data-field="name"
          :label="labels.name"
          required
          :disabled="Boolean(item.name)"
          :is-valid="validator.fields.name.valid"
          :validation-message="validator.fields.name.error"
        />
        <Address
          v-if="isActive && language"
          v-model="value.address"
          :label="labels.address"
          :disabled="Boolean(getDisabledField('address'))"
          v-tooltip.bottom="getDisabledField('address')"
          data-field="address"
          :language="language"
        />
        <CustomFields
          v-model="value.customFields"
          :schema="customFieldSchemas"
          :data="data"
          :placement="['basis', 'project:basis']"
          :validator="validator"
          validator-prefix="customFields"
          :disabledFields="$path('metadata.disabledFields.project', item)"
        />
      </div>

      <!-- 
        This feature is temporarily disabled until we have automated invoicing
      <component
        v-for="field in activeFields"
        :key="field.key + '--active'"
        v-model="value[field.key]"
        :is="field.component"
        :data-field="field.key"
        :validator="validator"
        v-on="field.listeners || {}"
      />

      <InputComponent
        v-if="inactiveFields.length"
        :label="$t('add') + ':'"
        class="project-mutate-basis__additional-fields"
      >
        <div v-for="field in inactiveFields" :key="field.key" class="project-mutate-basis__additional-fields-fields">
          <ButtonComponent :label="$t(field.key)" :icon="['fal', 'plus']" @click="addedFields.push(field.key)" />
        </div>
      </InputComponent>
      -->
    </template>
  </Card>
</template>

<script>
import Card from '@/components/Card'
import { InputComponent } from 'vue-elder-input'
import Billing from '@/components/Billing/Component'
import { Capitalize } from '@/utils'
import Address from '@/components/Address'
import CustomFields from '@kvass/custom-fields'
import { i18n } from '@/i18n'
import { mapState, mapGetters } from 'vuex'

const meta = {
  order: 1,
  id: 'basis',
  label: i18n.tc('basis'),
  icon: ['fal', 'file-alt'],
  fields: ['name', 'address'],
}

export { meta }
export default {
  props: {
    value: Object,
    labels: Object,
    data: Object,
    validator: Object,
    customFieldSchemas: { type: Array, default: () => [] },
    isActive: Boolean,
  },
  data() {
    return {
      displayNameState: false,
      addedFields: [],
      fields: [
        {
          key: 'billing',
          component: Billing,
          subkeys: ['company', 'organizationNumber', 'email', 'address'],
          listeners: {
            input: val => {
              if (!val) this.addedFields = this.addedFields.filter(f => f !== 'billing')
            },
          },
        },
      ],
    }
  },
  computed: {
    ...mapGetters('Project', ['getDisabledField']),
    ...mapState('Project', ['item']),
    activeFields() {
      return this.fields.filter(field => {
        if (this.addedFields.includes(field.key)) return true
        if (field.subkeys && field.subkeys.length) return field.subkeys.some(k => this.$path(k, this.value[field.key]))
        return Boolean(this.value[field.key])
      })
    },
    inactiveFields() {
      return this.fields.filter(field => !this.activeFields.find(item => item.key === field.key))
    },

    language() {
      return this.$path('metadata.language', this.item)
    },
  },
  methods: {
    Capitalize,
  },
  components: {
    Card,
    InputComponent,
    Address,
    CustomFields,
  },
}
</script>

<style lang="scss">
.project-mutate-basis {
  max-width: 900px;

  &__additional-fields {
    padding-top: 2rem;
    .elder-input__field {
      border: none;
    }
    &-fields {
      display: flex;
      align-items: center;
      gap: 1rem;

      .elder-button {
        font-size: 0.8em;
        border-radius: 20px;
      }
    }
  }

  &__input {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: $form-gap;
  }
}
</style>
